export class UserStatusBulkCommand {
    constructor(public id: string[], public status: string) {}
}
